import PagePatientSearch from './PagePatientSearch';

export default PagePatientSearch;



// WEBPACK FOOTER //
// ./src/views/pages/PatientSearch/index.js